import * as React from 'react';
import $ from "jquery";
import Common from '../../utilities/common';
import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, TextField, Typography } from '@mui/material';
import { User } from './User';
import { Entity, Permiso, PermissionLevel } from '../../utilities/Permisos';

export interface IUserNewProps {
    open: boolean;
    onClose?: Function;
    onSave?: Function;
}

export interface IUserNewState {
    open: boolean;
    hasErrors: boolean;
    errorMessage: string;
}

export default class UserNew extends React.Component<IUserNewProps, IUserNewState> {
    _user: User = new User();
    _permissionLevel: number = -1;
    
    public constructor(props: IUserNewProps) {
        super(props);

        this.state = {
            open: false,
            hasErrors: false,
            errorMessage: ''
        }
    }

    componentWillReceiveProps(nextProps: Readonly<IUserNewProps>, nextContext: any): void {
        this.setState({
            open: nextProps.open
        });
    }

    public render(): React.ReactElement<{}> {
        return (
            <Dialog open={this.state.open} fullWidth>
                <DialogTitle>
                    Nuevo usuario
                </DialogTitle>
                <DialogContent>
                    {
                        this.state.hasErrors && (
                            <Alert severity="error" style={{marginBottom: '10px'}}>
                                {
                                    this.state.errorMessage
                                }
                            </Alert>
                        )
                    }
                    <Box>
                        <FormControl fullWidth style={{marginBottom: '20px'}}>
                            <TextField required variant='standard' label='Nombre' onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                if(event.target.value == '') {
                                    this.setState(
                                        {
                                            hasErrors: true,
                                            errorMessage: 'Introduzca los valores correspondientes en los campos obligatorios o seleccione un archivo.'
                                        }
                                    );
                                }
                                else {
                                    this.setState(
                                        {
                                            hasErrors: false,
                                            errorMessage: ''
                                        }
                                    );
                                    this._user.nombre = event.target.value;
                                }
                            }}></TextField>
                        </FormControl>
                        <FormControl fullWidth style={{marginBottom: '20px'}}>
                            <TextField required variant='standard' label='Apellidos' onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                if(event.target.value == '') {
                                    this.setState(
                                        {
                                            hasErrors: true,
                                            errorMessage: 'Introduzca los valores correspondientes en los campos obligatorios o seleccione un archivo.'
                                        }
                                    );
                                }
                                else {
                                    this.setState(
                                        {
                                            hasErrors: false,
                                            errorMessage: ''
                                        }
                                    );
                                    this._user.apellidos = event.target.value;
                                }
                            }}></TextField>
                        </FormControl>
                        <FormControl fullWidth style={{marginBottom: '20px'}}>
                            <TextField required variant='standard' label='Email' onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                if(event.target.value == '') {
                                    this.setState(
                                        {
                                            hasErrors: true,
                                            errorMessage: 'Introduzca los valores correspondientes en los campos obligatorios o seleccione un archivo.'
                                        }
                                    );
                                }
                                else {
                                    this.setState(
                                        {
                                            hasErrors: false,
                                            errorMessage: ''
                                        }
                                    );
                                    this._user.userName = event.target.value;
                                }
                            }}></TextField>
                        </FormControl>
                        <FormControl variant="standard" fullWidth>
                            <InputLabel id="labelPermisos">Permiso inicial</InputLabel>
                            <Select label="Permiso inicial" labelId='labelPermisos' style={{textAlign: 'left'}} onChange={(event: SelectChangeEvent) => {
                                this._permissionLevel = Number(event.target.value);
                            }}>
                                <MenuItem value={1}>Ver</MenuItem>
                                <MenuItem value={2}>Editar</MenuItem>
                                <MenuItem value={3}>Eliminar</MenuItem>
                                <MenuItem value={4}>Crear</MenuItem>
                                <MenuItem value={5}>Administrar</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.Save.bind(this)}>OK</Button>
                    <Button onClick={this.Close.bind(this)}>Cancelar</Button>
                </DialogActions>
            </Dialog>
        )
    }

    private Close() {
        this.setState(
            {
                open: false,
                hasErrors: false,
                errorMessage: ''
            }
        );

        if(this.props.onClose != null) {
            this.props.onClose();
        }
    }

    private Save() {
        if(this._user.nombre == '' || this._user.nombre == null) {
            this.setState({
                hasErrors: true,
                errorMessage: 'Introduzca los valores correspondientes en los campos obligatorios o seleccione un archivo.'
            })
            return;
        }

        if(this._user.apellidos == '' || this._user.apellidos == null) {
            this.setState({
                hasErrors: true,
                errorMessage: 'Introduzca los valores correspondientes en los campos obligatorios o seleccione un archivo.'
            })
            return;
        }

        if(this._user.userName == '' || this._user.userName == null) {
            this.setState({
                hasErrors: true,
                errorMessage: 'Introduzca los valores correspondientes en los campos obligatorios o seleccione un archivo.'
            })
            return;
        }

        let url = `${Common.END_POINT}/masters/users`;
        $.ajax((
            {
                url: url,
                type: "POST",
                data: JSON.stringify(this._user),
                dataType: "json",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            const userId: number = response[0]['id'];
            const entities: number[] = [];

            for (const value in Entity) {
                if(!isNaN(Number(value))) {
                    entities.push(Number(value));
                }
            }

            console.log('entities', entities);

            if(this._permissionLevel == -1) {
                if(this.props.onSave != null) {
                    this.props.onSave();
                }
            }
            else {
                this.SetPermissions(userId, entities, 0);
            }

            this._user = new User();
        }).fail((jqXHR, textStatus, errorThrown) => {
            this.setState(
                {
                    open: false
                }
            );
    
            if(this.props.onSave != null) {
                this.props.onSave();
            }

            this._user = new User();
        });
    }

    private SetPermissions(userId: number, entities: number[], index: number) {
        if(index == entities.length) {
            if(this.props.onSave != null) {
                this.props.onSave();
            }

            return;
        }

        console.log(`Asignando permiso ${this._permissionLevel} a usuario ${userId} en entidad ${entities[index]}`);

        let permiso: Permiso = new Permiso();
        permiso.entidadId = entities[index];
        permiso.userId = userId;
        permiso.nivelPermisoId = this._permissionLevel;

        let url = `${Common.END_POINT}/permissions`;
        $.ajax((
            {
                url: url,
                type: "POST",
                data: JSON.stringify(permiso),
                dataType: "json",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done(() => {
            let newIndex = (index + 1);
            this.SetPermissions(userId, entities, newIndex);
        }).fail((jqXHR, textStatus, errorThrown) => {
            if(this.props.onSave != null) {
                this.props.onSave();
            }
            return;
        });
    }
}